<template>
	<li 
		class="assessment__item"
		:class="{'is-completed': isCompleted, active: activeId === quiz.id }">
		<span class="assessment-icon"></span>
		<router-link
			:to="{ name: '' }">
			<h6 class="bold">{{quiz.title}}</h6>
			<span 
				v-if="quiz.subtitle" 
				class="secondary">Sum, Difference & Multiplication</span>
		</router-link>
	</li>
</template>

<script>
import eventHub from '../../utils/eventhub';

export default {
	name: 'TestItem',
	props: {
		quiz: {
			type: Object,
			default() {
				return {};
			}
		},
		activeId: {
			type: Number,
			default() {
				return null;
			}
		}
	},
	data() {
		return {
			isCompleted: false,
			isActive: false
		};
	},
	created() {
		eventHub.$emit('set-duration', this.quiz.duration);
	}
};
</script>

<style lang="scss" scoped>
.assessment__item {
	&.active {
		background: $green!important;
		color: $white;
		.assessment-icon {
			border-color: $white!important;
		}
	}
	.assessment-icon {
		top: 45%;
	}
}

</style>
